import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const PayPalMessage = ({price}) => {
    const {
        app: {commerceAPI}
    } = getConfig()
    const {paypal} = commerceAPI
    const {configPaypal} = paypal || {}

    var paypalMinTotal = 50.0
    var scriptUrl = null
    var enableCartCallout = false

    try {
        const jsonConfig = JSON.parse(configPaypal)

        paypalMinTotal = jsonConfig.minTotal
        scriptUrl = jsonConfig.scriptURL
        enableCartCallout = jsonConfig.enableCartCallout
    } catch (e) {
        console.log(e.message)
    }

    useEffect(() => {
        if (!scriptUrl && !enableCartCallout) {
            return
        }
        const scriptId = 'paypal-sdk'

        const renderPayPalMessages = () => {
            if (window.paypal?.Messages) {
                window.paypal.Messages().render('.paypal-message-container')
            }
        }

        // Check if PayPal script already exists
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script')
            script.src = scriptUrl
            script.async = true
            script.setAttribute('data-script-loaded', 'true')
            script.id = scriptId
            script.onload = renderPayPalMessages
            document.body.appendChild(script)
        } else {
            renderPayPalMessages()
        }
    }, [scriptUrl, enableCartCallout])

    return (
        paypalMinTotal &&
        paypalMinTotal < price &&
        enableCartCallout && (
            <Box id={`paypal-message-cart`}>
                <div className="paypal-bnpl">
                    <div
                        className="paypal-message-container"
                        data-pp-message
                        data-pp-placement="cart"
                        data-pp-amount={price}
                        data-pp-style-logo-type="inline"
                        data-pp-style-text-color="grayscale"
                        data-pp-style-text-size="12"
                    ></div>
                </div>
            </Box>
        )
    )
}

PayPalMessage.propTypes = {
    price: PropTypes.any
}

export default PayPalMessage
